import { trackEvent as t } from '../track';

export const peopleSidebar = {
  search: () => t('[People Sidebar] Initiated search'),
  selectPerson: () => t('[People Sidebar] Select person'),
};
